// extracted by mini-css-extract-plugin
export default {"splitter":"splitter__splitter___fOAg7","handleBar":"splitter__handleBar___yvA5I"};